export interface TelegramWebApp {
  initData: string;
  initDataUnsafe?: { start_param?: string };
  isVersionAtLeast?(version: string): boolean;
  colorScheme?: 'light' | 'dark';
  themeParams?: Record<string, string>;
  ready(): void;
  expand(): void;
  close(): void;
  openTelegramLink(url: string): void;
  shareToStory?(
    mediaUrl: string,
    params?: { text?: string; widget_link?: { url: string; name?: string } },
  ): void;
  onEvent(event: string, callback: () => void): void;
  offEvent(event: string, callback: () => void): void;
  BackButton: {
    show(): void;
    hide(): void;
    onClick(callback: () => void): void;
    offClick(callback: () => void): void;
  };
  HapticFeedback?: { notificationOccurred(type: 'error' | 'success' | 'warning'): void };
  requestWriteAccess?(callback?: (granted: boolean) => void): void;
  enableClosingConfirmation?(): void;
  disableClosingConfirmation?(): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function getTelegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function applyTelegramTheme(webApp: TelegramWebApp): void {
  const root = document.documentElement;
  for (const [key, value] of Object.entries(webApp.themeParams ?? {})) {
    root.style.setProperty(`--tg-theme-${key.replaceAll('_', '-')}`, value);
  }
  applyStoredAppearance(webApp.colorScheme);
}
import { applyStoredAppearance } from './appearance.js';
